import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register, formatApiErrorDetail } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await register(form.name, form.email, form.password);
      toast.success(`Welcome, ${u.name}`);
      nav("/");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Sign up failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fade-in max-w-md mx-auto px-6 py-24" data-testid="register-page">
      <div className="font-micro text-[#8A8680] mb-4">Studio Access</div>
      <h1 className="font-serif text-[#EDE4D3] text-5xl mb-10">Create account.</h1>
      <form onSubmit={submit} className="space-y-6">
        <input className="input-teak" placeholder="Full name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="register-name" />
        <input className="input-teak" type="email" placeholder="Email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="register-email" />
        <input className="input-teak" type="password" placeholder="Password (min 6)" minLength={6} required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="register-password" />
        <button className="btn-bronze w-full" type="submit" disabled={busy} data-testid="register-submit">{busy ? "Creating…" : "Create account"}</button>
      </form>
      <div className="mt-8 text-[#8A8680] font-micro">
        Already have one? <Link to="/login" className="text-[#B8895C] link-underline">Sign in</Link>
      </div>
    </div>
  );
}
